// extracted by mini-css-extract-plugin
export default {"button":"BackToTopButton_button__Pvf4X","slideLeft":"BackToTopButton_slideLeft__a+iLl","hidden":"BackToTopButton_hidden__pCgrF"};